import { render } from "./Stage.vue?vue&type=template&id=5be9e0f1&scoped=true&ts=true"
import script from "./Stage.vue?vue&type=script&lang=ts"
export * from "./Stage.vue?vue&type=script&lang=ts"

import "./Stage.vue?vue&type=style&index=0&id=5be9e0f1&lang=scss&scoped=true"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be9e0f1"]])

export default __exports__